<template>
  <div id="app" style="width: 100%;">

    <TopNav :linktype="putCount_Json.linktype" :adlist3="putCount_Json.adlist3" style="position: fixed;width: 100%;top: 0;z-index: 9999;"></TopNav>

    



    <el-container class="scrollbar" style="height: 100vh;">
      <el-aside width="200px" style="padding-top: 90px;background-color: rgb(51, 51, 51)" class="hidden-sm-and-down">
        
        <el-collapse v-model="activeNames" @change="handleChange">
          
          <a href="/">
            <div style="padding-left: 20px;" class="el-collapse-item__header">
                                                
              <i class="fa-solid fa-house-chimney"></i>
              <span style="padding-left: 5px;">홈</span>  

            </div>
          </a>

          <router-link to="Top">
            <div style="padding-left: 20px;" class="el-collapse-item__header">
              <div>
                <i style="color:red;" class="fa-solid fa-fire fa-beat"></i>
                <span style="padding-left: 5px;">인기영상</span>
              </div>
            </div>
          </router-link>
          
          <el-collapse-item name="1">
            <template slot="title">
              <span style="padding-left: 20px;">
                <i class="fa-solid fa-tv"></i> VOD
              </span>
            </template>
            <div>

              <div style="padding-left: 20px;">
                <el-collapse-item name="1-1">
                  <template slot="title">
                    <span style="padding-left: 20px;">
                      <i style="color:#55f;" class="fa-solid fa-circle-play"></i>
                      영화
                    </span>
                  </template>
                  <div style="padding-left: 40px;">
                    
                    <router-link to="Type?type=1&type2=137">
                      <div class="left_menu_s">한국 영화</div>
                    </router-link>
                    <router-link to="Type?type=1&type2=9999">
                      <div class="left_menu_s">해외 영화</div>
                    </router-link>

                  </div>
                </el-collapse-item>

              </div>

              <div style="padding-left: 20px;">
                <el-collapse-item name="1-2">
                  <template slot="title">
                    <span style="padding-left: 20px;">
                      <i style="color:#bbff66;" class="fa-solid fa-video"></i>
                      드라마
                    </span>
                  </template>
                  <div style="padding-left: 40px;">
                    
                    <router-link to="Type?type=2&type2=3">
                      <div class="left_menu_s">한국 드라마</div>  
                    </router-link>
                    <router-link to="Type?type=2&type2=9999">
                      <div class="left_menu_s">해외 드라마</div>
                    </router-link>

                  </div>
                </el-collapse-item>

              </div>

              <div style="padding-left: 40px;">
                
                <router-link to="Type?type=3">
                  <div class="left_menu_s">예능</div>
                </router-link>
                <router-link to="Type?type=4">
                  <div class="left_menu_s">시사</div>
                </router-link>
                <router-link to="Type?type=5">
                  <div class="left_menu_s">애니메이션</div>
                </router-link>
                <router-link to="Type?type=6">
                  <div class="left_menu_s">OTT예능</div>
                </router-link>
                <router-link to="Type?type=9">
                  <div class="left_menu_s">지난드라마</div>
                </router-link>
              </div>

            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span style="padding-left: 20px;">
                <i class="el-icon-link"></i> 링크동맹
              </span>
            </template>
            <div style="padding-left: 40px;">
              <router-link :to="'Link?type='+item.type" v-for="(item,index) in putCount_Json.linktype" :key="index">
                <div class="left_menu_s">{{ item.title }}</div>
              </router-link>
            </div>
          </el-collapse-item>

        </el-collapse>

        <!-- <div style="padding-left: 16px;" class="el-collapse-item__header">
          <div>
            
            <a href="https://herb-ming.com/?re=bbtv" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/ico10.png" width="20" alt="">
              <span style="padding-left: 5px;">비아그라 / 위고비</span>
            </a>

          </div>
        </div> -->


        <!-- 广告 -->
        <div style="margin-bottom: 20px;">

          <el-row :span="24" :gutter="0">

            <el-col :span="24" v-for="(item,index) in putCount_Json.adlist3" :key="index">
              
              <a :href="item.url" target="_blank" rel="noopener noreferrer">
                <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="item.image" fit="cover" >
                  <template #error>
                    <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                  </template>
                </el-image>
              </a>

            </el-col>

          </el-row>

          </div>
          <!-- 广告 -->

      </el-aside>
      
      <el-container>       
        <el-main>
<!-- 
          <div class="notice">
			<ul> -->
			
	
				<!--li><a>접속이 차단 되었을때의 비상 주소에 대해 알려드립니다 지금 바로 확인하세요 �</a></li-->
				<!-- <li><a href="#">땡땡티비에 오신걸 환영합니다.접속 차단시 다음 접속도메인은 ootv42.com입니다.</a></li>

					</ul>		
		</div> -->
    

          <router-view id="pagetop"/>
            
          <MyFooter @putCount="putCount"></MyFooter>

        </el-main>
      </el-container>
    </el-container>

  </div>
</template>
<script>
import TopNav from '@/components/TopNav.vue'
import MyFooter from '@/components/MyFooter.vue'
export default {
  components: {
    TopNav,
    MyFooter
  },
  metaInfo() {
    return {
      title: this.putCount_Json.head.title, // 使用计算属性或方法获取动态值
      meta: this.putCount_Json.head.meta
    }
  },
  data(){
    return{
      activeNames: ['0'],
      putCount_Json:{
        pageviews:{
          best:'-',
          today:'-',
          month:'-',
          all:'-'
        },
        adlist3:[],
        linktype:[],
        head:{
          title: '별별티비 -   영화, 드라마, 예능, 오리지널 무료 다시보기',
          meta: []
        }
      },
    }
  },
  methods: {
    updateMetaInfo(title, description) {
      this.metaInfo.title = title;
      this.metaInfo.description = description;
    },
    putCount(value){
      // console.log(value)
      this.putCount_Json = value

      let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
      this.putCount_Json.adlist3.forEach(function(item){
          if(item.rand=='0'){
          Temp_Rand_Arr.push(item)
          }else{
          Temp_No_Rand_Arr.push(item)
          }
      })
      Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
      this.putCount_Json.adlist3 = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

      
      // this.updateMetaInfo("title", "description")
    },
    handleChange(e){

    }
  }
}
</script>
<style>
body{
  background-color: #000;
  margin: 0;padding: 0;
  color: #fff;
  font-size: 12px;
  /* font-family: '환_세나루'; */
  font-family:'Source Sans Pro';
  line-height: 20px;
}
.size-body{
  margin: 20px auto;
  max-width: 1880px;

}

.scrollbar {

  /* 修改整个滚动条的宽度 */
  ::-webkit-scrollbar {
    width: 3px;
    /* 宽度 */
    height: 12px;
    /* 高度 */
  }

  /* 修改滚动条轨道的颜色 */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 轨道颜色 */
  }

  /* 修改滑块的颜色 */
  ::-webkit-scrollbar-thumb {
    background: #888;
    /* 滑块颜色 */
  }

  /* 当滑块悬停时 */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滑块悬停颜色 */
  }
}

.el-collapse{
  border-top: none !important;
}
.el-collapse-item__wrap{
  border-bottom: none !important;
}
.el-collapse-item__header{
  color: #fff !important;
  background-color: #333 !important;
  border-bottom: 1px solid #000 !important;
}
.el-collapse-item__content{
  /* padding-bottom: 0 !important; */
  padding: 10px 0 !important;
  background-color: rgb(51, 51, 51);
  border: none;
}
.el-collapse-item__header2{
  color: #fff !important;
  background-color: #333 !important;
  border-bottom: none !important;
  /* height: 20px !important; */
  line-height: 20px !important;
}

.left_menu_s{
  padding: 5px 0;
  color: #fff;
  /* background-color: rgb(51, 51, 51); */
}

/* 通用bg颜色 */
.row-bg{
  background-color: #333;
}

.one_line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

a {
  color: inherit; /* 或者设置为和正文文字颜色一致 */
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a.custom-link {
  text-decoration: none;
}

.title-s{
  padding-top: 20px;
  font-size: 20px;
  line-height: 55px;
  font-weight: 0;
  font-family: 'GUDESIGN';
}

.card{
  margin: 2px 0;
}
.card .ending {
    /* background: linear-gradient(to right, #2577e3 0, #589cf6 70%); */
    background: linear-gradient(to right, #fc0000 0, #ff8888 70%);
    /* box-shadow: 0px 3px 3px rgba(0,0,0,.2); */
    box-shadow: 0px 3px 3px rgba(24, 24, 24, 0.185);
}
.card .ending {
    color: #fff;
    position: absolute;
    top: 15px;
    left: 0px;
    padding: 2px 15px;
    text-align: right;
    font-size: 12px;
    font-weight: bold;
    z-index: 1;
}

/* 全局样式 */
.el-tooltip__popper {
  width: 150px; /* 设置你想要的宽度 */
}

@font-face {
  font-family: 'UTTM';
  src: url('~@/assets/fonts/UTTM.woff') format("woff"), url('~@/assets/fonts/UTTM.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
.font_UTTM {
  font-family: 'UTTM';
}

@font-face {
  font-family: 'TSDR';
  src: url('~@/assets/fonts/TSDR.woff') format("woff"), url('~@/assets/fonts/TSDR.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.font_tsdr {
  font-family: 'TSDR';
}

@font-face {
  font-family: 'GUDESIGN';
  src: url('~@/assets/fonts/GUDESIGN.woff') format("woff"), url('~@/assets/fonts/GUDESIGN.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.font_gudesign {
  font-family: 'GUDESIGN';
}

@font-face {
  font-family: '환_세나루';
  src: url('~@/assets/fonts/환_세나루.woff') format("woff"), url('~@/assets/fonts/환_세나루.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.font_환_세나루 {
  font-family: '환_세나루';
}

.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #333 !important;
}




.custom-icon {
  position: relative;
  font-size: 10px;
  top:0px;
  margin: 0;
  padding: 0;
  /* width: 50px;
  height: 50px; */
  /* display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  margin: 0 5px; */
}
</style>
